// extracted by mini-css-extract-plugin
export default {"modalContainer":"permissions-manager_modalContainer__XIyQc","content":"permissions-manager_content__EnowF"};